const businessModel = `about
addresses {
  address1
  address2
  address3
  address4
  city
  countryCode
  id
  latitude
  longitude
  primary
  name
  postalCode1
  province
}
claimed
classifications {
  abbreviation
  key
  name
}
constructionSectors
coverageAreas {
  admin1
  admin2
  admin3
  admin4
  countryCode
  googlePlaceId
  locality
  selectedLevel
}
createdAt
dba
id
logoUrl
name
phone
primarySlug
providedServices {
  id
  key
  level
}
businessTypes
updatedAt
website
companySize {
  start
  end
}
avgContractSize {
  start
  end
}
visibility {
  published
  receiveBidInvitations
  showProcoreActivity
}
companyId`;

const paginatedAddressModel = `
edges {
  node {
    address1
    address2
    address3
    address4
    addressTypes
    city
    province
    countryCode
    latitude
    longitude
    id
    name
    phoneNumber
    postalCode1
    primary
  }
}
pageInfo {
  endCursor
  hasNextPage
}
`;

const metricsModel = `
    businessId
    totalProjects
    activeProjects
    rfisCompleted
    numberOfOpenRfi
    numberOfProjectsWithOpenRfi
    submittalsCompleted
    averageTimeToSubmittal
    freemiumTotalProjects
    freemiumTotalActiveProjects
    freemiumAvgProjectSize
    freemiumNumOfEmployees
`;

module.exports = { businessModel, paginatedAddressModel, metricsModel };
